var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.UniqueId = {
    options: {
        unique_id_base_string: 'xxxxxxxx_xxxx_4xxx_yxxx_xxxxxxxxxxxx',
        unique_id_prepend_string: ''
    },
    /**
     * @method create_id Used to create a unique id.
     * @returns {String}
     */
    create_unique_id: function () {
        var d = new Date().getTime();
        var uuid = this.options.unique_id_base_string.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16);
        });
        return this.get_unique_prepend_strings() + uuid;
    },
    get_unique_prepend_strings: function() {
        var prepend = "";
        if (this.options.unique_id_prepend_string) {
            prepend = this.options.unique_id_prepend_string + prepend;
        }
        if (this.class_name && this.class_name !== "UniqueIdGen") {
            prepend = this.class_name + "_" + prepend;
        }
        if (this.class_type && this.class_type !== "UniqueIdGen") {
            prepend = this.class_type + "_" + prepend;
        }  
        return prepend;
    }
};